import React, { useEffect } from 'react';
import useReactRouter from 'use-react-router';
import { CHATBOT_EDITOR } from '../../../../../common/constants/routes';

type Props = {
  createMessengerAd: () => Promise<void>;
  botId: number;
};

const NewMessengerAd = ({ createMessengerAd, botId }: Props) => {
  const { history } = useReactRouter();

  useEffect(() => {
    const createAd = async () => {
      await createMessengerAd();
      history.push(`${CHATBOT_EDITOR}/${botId}/messenger-ads`);
    };

    createAd();
  }, []);

  return <div />;
};

export default NewMessengerAd;
